import React, { useState, useEffect } from 'react';
import { FaArrowRight, FaArrowLeft, FaCross } from 'react-icons/fa';
const outreach = require("../assets/unreached.jpeg");
const churchplanting = require("../assets/outreachministries.jpeg");
const communityOutreach = require("../assets/communityOutreach.jpeg");
const Discipleship = require("../assets/Discipleship.jpeg");

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

   const slides = [
     {
       id: 1,
       imageUrl: outreach,
       title: 'Life Missions Ministry',
       description: 'We love because God first loved us. — 1 John 4:19',
       cta: 'Join Our Mission'
     },
     {
       id: 2,
       imageUrl: churchplanting,
       title: 'Church Planting',
       description: 'Establishing Christ-centered churches in unreached communities',
       cta: 'Support Church Planting'
     },
     {
       id: 3,
       imageUrl: Discipleship,
       title: 'Discipleship Training',
       description: 'Equipping believers to grow in their faith and serve others',
       cta: 'Learn About Discipleship'
     },
     {
       id: 4,
       imageUrl: communityOutreach,
       title: 'Community Outreach',
       description: 'Demonstrating Christ\'s love through practical service',
       cta: 'Volunteer With Us'
     }
   ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentSlide(prev => (prev === slides.length - 1 ? 0 : prev + 1));
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHovered, slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide(prev => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <div 
      className="relative w-full h-[70vh] md:h-screen max-h-[1000px] overflow-hidden"
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => !isMobile && setIsHovered(false)}
    >
      {/* Slides container */}
      <div className="flex h-full transition-transform duration-700 ease-out">
        {slides.map((slide, index) => (
          <div 
            key={slide.id} 
            className="w-full flex-shrink-0 relative"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {/* Background image */}
            <div className="absolute inset-0 overflow-hidden">
              <img
                src={slide.imageUrl}
                alt={slide.title}
                className="w-full h-full object-cover"
                loading={index === 0 ? 'eager' : 'lazy'}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            </div>

            {/* Content */}
            <div className="relative h-full flex flex-col justify-center items-center text-center px-6 text-white">
              <div className="max-w-4xl mx-auto space-y-4 md:space-y-6 transition-all duration-500 ease-out"
                   style={{
                     transform: currentSlide === index ? 'translateY(0)' : 'translateY(20px)',
                     opacity: currentSlide === index ? 1 : 0
                   }}>
                <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight">
                  {slide.title}
                </h2>
                <p className="text-lg md:text-xl lg:text-2xl max-w-2xl mx-auto">
                  {slide.description}
                </p>
                <button className="mt-4 md:mt-8 px-6 py-3 md:px-8 md:py-4 bg-blue-600 hover:bg-blue-700 rounded-full text-base md:text-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl">
                  {slide.cta}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-2 md:left-8 top-1/2 -translate-y-1/2 bg-white/20 backdrop-blur-md p-2 md:p-4 rounded-full hover:bg-white/30 transition-all duration-300"
        aria-label="Previous slide"
      >
        <FaArrowLeft className="h-5 w-5 md:h-6 md:w-6" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 md:right-8 top-1/2 -translate-y-1/2 bg-white/20 backdrop-blur-md p-2 md:p-4 rounded-full hover:bg-white/30 transition-all duration-300"
        aria-label="Next slide"
      >
        <FaArrowRight className="h-5 w-5 md:h-6 md:w-6" />
      </button>

      {/* Dot indicators */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${currentSlide === index ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/70'}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Mobile swipe indicator */}
      {isMobile && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-white text-xs opacity-70">
          Swipe to navigate
        </div>
      )}
    </div>
  );
};

export default Slider;